import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { AdvertisingDisclosure } from '@xsite-ui/common.advertising-disclosure';
import { cdnData } from '@xsite-ui/common.cdn';
import IconButton from '@xsite-ui/common.icon-button';
import { Image } from '@xsite-ui/common.image';
import Link from '@xsite-ui/common.link';
import { RightSideLinkDataRoles } from '@xsite-ui/common.rapido';
import React from 'react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import styled from '@emotion/styled';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
var darkGreen = '#225447';
var white = '#ffffff';
var minDesktopWidth = '800px';
var FooterWrapper = styled.footer(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background-color: ", ";\n  font-family: ", ";\n  font-weight: 400;\n  width: 100%;\n  padding: 64px;\n  display: flex;\n  justify-content: center;\n  z-index: 10;\n  position: relative;\n  flex-direction: column;\n  color: ", ";\n  font-size: 14px;\n\n  @media (min-width: ", ") {\n    display: flex;\n    align-items: center;\n  }\n"])), function (_ref) {
  var _theme$variants, _theme$variants$foote;

  var theme = _ref.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$variants = theme.variants) === null || _theme$variants === void 0 ? void 0 : (_theme$variants$foote = _theme$variants.footer) === null || _theme$variants$foote === void 0 ? void 0 : _theme$variants$foote.backgroundColor) || darkGreen;
}, function (_ref2) {
  var _theme$fonts;

  var theme = _ref2.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.body) || 'inherit';
}, function (_ref3) {
  var _theme$variants2, _theme$variants2$foot;

  var theme = _ref3.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$variants2 = theme.variants) === null || _theme$variants2 === void 0 ? void 0 : (_theme$variants2$foot = _theme$variants2.footer) === null || _theme$variants2$foot === void 0 ? void 0 : _theme$variants2$foot.color) || white;
}, minDesktopWidth);
var Container = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  max-width: 756px;\n\n  @media (min-width: ", ") {\n    display: flex;\n    flex-direction: row;\n    max-width: 2025px;\n  }\n"])), minDesktopWidth);
var MenuAndLicensesWrapper = styled.section(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    display: flex;\n    flex-direction: column;\n    max-width: 756px;\n\n    nav:nth-of-type(1) {\n      order: -1;\n    }\n  }\n"])), minDesktopWidth);
var LogoAndLegalWrapper = styled.section(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    margin-inline-end: 65px;\n    max-width: 235px;\n    display: flex;\n    flex-direction: column;\n  }\n"])), minDesktopWidth);
var LogoLegal = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-inline-end: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var FooterSiteLogoLink = styled.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 32px;\n  width: 148px;\n\n  & > {\n    width: 100%;\n  }\n"])));
var Copyright = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  line-height: 18px;\n\n  a {\n    color: ", ";\n  }\n\n  @media (min-width: ", ") {\n    flex-grow: ", ";\n  }\n"])), white, minDesktopWidth, function (props) {
  return !props.isMobile && 1;
});
var FooterLink = styled.a(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  line-height: 19px;\n  font-weight: 600;\n  transition: 0.3s ease-in-out;\n  text-decoration: none;\n  color: inherit;\n\n  :hover {\n    opacity: 80%;\n  }\n"])));
styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 400;\n\n  > a {\n    margin-bottom: 16px;\n    line-height: 19px;\n    font-weight: 600;\n    transition: 0.3s ease-in-out;\n    text-decoration: none;\n    color: inherit;\n\n    :hover {\n      opacity: 80%;\n    }\n  }\n"])));
var DisclosureContainer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 31px 0;\n  border-bottom: 1px solid ", ";\n  border-top: 1px solid ", ";\n\n  @media (min-width: ", ") {\n    padding-top: 0;\n    border: none;\n  }\n"])), white, white, minDesktopWidth);
var Menu = styled.nav(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin-top: 57px;\n  display: flex;\n  flex-direction: column;\n\n  > a {\n    font-weight: 700;\n\n    :not(:last-child) {\n      margin: 0 0 36px;\n      white-space: nowrap;\n    }\n  }\n\n  @media (min-width: ", ") {\n    margin: 0;\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n  }\n"])), minDesktopWidth);
var LeftSideLinks = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n"])));
var LeftSideLink = styled.a(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  text-decoration: none;\n  color: ", ";\n"])), function (_ref4) {
  var _theme$variants3, _theme$variants3$foot;

  var theme = _ref4.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$variants3 = theme.variants) === null || _theme$variants3 === void 0 ? void 0 : (_theme$variants3$foot = _theme$variants3.footer) === null || _theme$variants3$foot === void 0 ? void 0 : _theme$variants3$foot.color) || white;
});
var Disclosure = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n  }\n"])), white);
var SocialIcons = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 15px;\n  margin-bottom: 30px;\n"])));
styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral([""])));
var AppsStoresContainer = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var AppsStoresHeader = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 700;\n"])));
var AppsStores = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 24px 0;\n  gap: 10px;\n"])));
var Icon = styled.img(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  width: 20px;\n  height: 20px;\n"])));
var Logo = styled(Image)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  max-width: 148px;\n  max-height: 50px;\n"])));

var Footer = function Footer(props) {
  var footerLogoSrc = props.footerLogoSrc,
      copyright = props.copyright,
      _props$advertisingDis = props.advertisingDisclosureProps,
      _props$advertisingDis2 = _props$advertisingDis.title,
      title = _props$advertisingDis2 === void 0 ? '' : _props$advertisingDis2,
      _props$advertisingDis3 = _props$advertisingDis.text,
      text = _props$advertisingDis3 === void 0 ? '' : _props$advertisingDis3,
      disclosure = props.disclosure,
      rightSideLinks = props.rightSideLinks,
      leftSideLinks = props.leftSideLinks,
      isMobile = props.isMobile,
      socialIcons = props.socialIcons,
      appsStores = props.appsStores,
      cdnContextProps = props.cdnContextProps,
      className = props.className;

  var _ref = cdnContextProps !== null && cdnContextProps !== void 0 ? cdnContextProps : {},
      _ref$assetsCdn = _ref.assetsCdn,
      assetsCdn = _ref$assetsCdn === void 0 ? {} : _ref$assetsCdn,
      _ref$env = _ref.env,
      env = _ref$env === void 0 ? '' : _ref$env;

  var rightSideLinksCustom = isMobile && leftSideLinks ? [].concat(_toConsumableArray(leftSideLinks), _toConsumableArray(rightSideLinks)) : rightSideLinks;
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    "data-testid": "footer-wrapper",
    "data-role": "footer",
    className: className
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(LogoAndLegalWrapper, null, /*#__PURE__*/React.createElement(LogoLegal, null, /*#__PURE__*/React.createElement(FooterSiteLogoLink, {
    href: "/",
    "data-testid": "footer-logo-image",
    className: "footer-logo-image"
  }, /*#__PURE__*/React.createElement(Logo, {
    src: footerLogoSrc,
    alt: "site logo"
  })), isMobile && appsStores && (appsStores === null || appsStores === void 0 ? void 0 : appsStores.length) > 0 && /*#__PURE__*/React.createElement(AppsStoresContainer, {
    "data-testid": "apps-stores"
  }, /*#__PURE__*/React.createElement(AppsStoresHeader, null, "Download The App"), /*#__PURE__*/React.createElement(AppsStores, null, appsStores.map(function (imgProp, idx) {
    return /*#__PURE__*/React.createElement(Link, {
      href: imgProp.url,
      target: "_blank",
      key: idx,
      "data-role": imgProp.dataRole
    }, /*#__PURE__*/React.createElement(Image, {
      src: imgProp.logo,
      alt: imgProp.alt,
      lazy: true
    }));
  }))), leftSideLinks && (leftSideLinks === null || leftSideLinks === void 0 ? void 0 : leftSideLinks.length) > 0 && !isMobile && /*#__PURE__*/React.createElement(LeftSideLinks, {
    "data-testid": "left-side-links"
  }, leftSideLinks.map(function (link, index) {
    return /*#__PURE__*/React.createElement(LeftSideLink, {
      key: index,
      href: link.url,
      "data-role": link.dataRole
    }, link.text);
  })), /*#__PURE__*/React.createElement(Copyright, {
    dangerouslySetInnerHTML: {
      __html: copyright
    },
    isMobile: isMobile
  }), socialIcons && (socialIcons === null || socialIcons === void 0 ? void 0 : socialIcons.length) > 0 && /*#__PURE__*/React.createElement(SocialIcons, {
    "data-testid": "social-icons"
  }, socialIcons.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        url = _ref2.url;
    return /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        src: cdnData(icon === null || icon === void 0 ? void 0 : icon.url, assetsCdn, env)
      }),
      variant: "primary",
      as: "a",
      href: url,
      key: idx,
      target: "_blank"
    });
  })))), /*#__PURE__*/React.createElement(MenuAndLicensesWrapper, null, /*#__PURE__*/React.createElement(DisclosureContainer, null, /*#__PURE__*/React.createElement(Disclosure, {
    dangerouslySetInnerHTML: {
      __html: disclosure
    }
  })), /*#__PURE__*/React.createElement(Menu, {
    "data-testid": "right-side-links",
    className: "right-side-links"
  }, rightSideLinksCustom === null || rightSideLinksCustom === void 0 ? void 0 : rightSideLinksCustom.map(function (link, index) {
    return link.dataRole !== RightSideLinkDataRoles.AD_DISCLOSURE ? /*#__PURE__*/React.createElement(FooterLink, {
      key: index,
      href: link.url,
      "data-role": link.dataRole
    }, link.text) : /*#__PURE__*/React.createElement(AdvertisingDisclosure, {
      key: index,
      text: text,
      title: title,
      isDisclosureInFooter: true,
      "data-testid": "ad-disclosure"
    });
  })))));
};

Footer.displayName = 'Footer';

export { Footer as F, FooterLink as a };
